<template>
  <div class="sync">
    <BaseSpinner size="2rem" />
  </div>
</template>

<script>
import BaseSpinner from '@/components/BaseSpinner/BaseSpinner'
import subscriptionService from '@/services/api/services/subscriptionService'
export default {
  components: {
    BaseSpinner
  },
  async created() {
    await subscriptionService.sync()
    await this.$store.dispatch('authenticate')
    this.$router.push('/discounts')
  }
}
</script>

<style lang="scss" scoped>
.sync {
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: var(--spacing-5);
}
</style>
